/* Manages profile objects and the mood rating customization form on one_day */
import $ from 'jquery';
import _ from 'underscore';
import Backbone from 'backbone';
import ProfileModel from 'models/profile';


export default Backbone.View.extend({
  $anchor_low: $('#anchor-low', '#mood-rater'),
  $anchor_high: $('#anchor-high', '#mood-rater'),
  profile: new ProfileModel(),
  editing: false,
  initialize: function (options) {
    _.bindAll(this, 'render', 'edit_profile_event');

    this.parent_view = options.parent_view;

    this.profile.fetch({ success: this.render });
    var self = this;
    $('.icon-edit').on('click', function (event) {
      self.edit_profile_event(self, event);
    });
  },
  render: function () {
    this.$anchor_low.text(this.profile.get('anchor_low'));
    this.$anchor_high.text(this.profile.get('anchor_high'));
    // Recompute smiley registration
    this.parent_view.smileyView.setInitialData();
  },
  edit_profile_event: function (self, event) {
    // Toggles the mood ratings between labels and a form.
    // If the mood ratings are form elements, save any changes
    event.preventDefault();
    var $source = $(event.srcElement);
    var profile = self.profile;
    var anchor_low_text, anchor_high_text;
    // Toggle html elements between labels and a form
    if (!self.editing) {
      self.editing = true;
      self.anchor_text = $source.html();
      // $source.html('Save');
      anchor_low_text = self.$anchor_low.text();
      anchor_high_text = self.$anchor_high.text();
      self.$anchor_low.html(
        '<input type="text" value="' + anchor_low_text + '" maxlength="23">'
      );
      self.$anchor_high.html(
        '<input type="text" value="' + anchor_high_text + '" maxlength="23">'
      );
    } else {
      // Toggle back to display values and save
      self.editing = false;
      $source.html(self.anchor_text);
      anchor_low_text = $('input', self.$anchor_low).val();
      anchor_high_text = $('input', self.$anchor_high).val();
      self.profile.save({
        anchor_low: anchor_low_text,
        anchor_high: anchor_high_text
      });
      self.$anchor_low.html(self.profile.get('anchor_low'));
      self.$anchor_high.html(self.profile.get('anchor_high'));
    }
  }
});



// WEBPACK FOOTER //
// ./static/js/views/profile.js